import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { IdentityUser } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service';
import { IJsonApiResponse } from '@reg/shared/json-api/json-api.interface';

/**
 * Service to get and save user data.
 */
@Injectable()
export class IdentityUserService {
    public static INCLUDE_PERSON: string = 'person';
    public static INCLUDE_ASSESSORS: string = 'assessors';

    private readonly identityApiBaseUrl: string;

    constructor(private http: HttpServiceHelper) {
        this.identityApiBaseUrl = http.configService.getBaseConfig('identityApiBaseUrl');
    }

    /**
     * Add or update the user
     */
    public createIfNotExists(user: IdentityUser, includes: string[] = null): Observable<IdentityUser> {
        const apiRequestUrl: string = this.getApiUrl(user.id, includes);
        const response: Observable<IJsonApiResponse> = this.http.post(apiRequestUrl, user.serialize());

        return response.pipe(map((response: IJsonApiResponse) => (new IdentityUser()).deserialize(response)));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(userId: string, includes: string[] = null, queryParams: string[] = null): string {
        let url: string = `${this.identityApiBaseUrl}/users/`;

        if (userId) {
            url += userId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
